import callApi from 'helpers/callApi';

export const getTeachers = (params) => callApi({ url: '/teachers', query: params });
export const getAllTeachers = (params) => callApi({ url: '/teachers', query: { ...params, limit: 10000, page: 1 } });

export const getTeacherById = (id) => callApi({ url: `/teachers/${id}` });
export const getTeacherClassesById = (id, params) => callApi({ url: `/teachers/${id}/classes`, query: params });
export const getTeacherRevenueList = (id, params) => callApi({ url: `/teachers/${id}/revenue-list`, query: params });
export const getTeacherRevenue = (id, params) => callApi({ url: `/teachers/${id}/revenue`, query: params });
export const getTransactionList = (id, params) => callApi({ url: `/teachers/${id}/transactions`, query: params });

export const verifyBankAccount = (id) => callApi({ url: `/teachers/${id}/verify/bank-account`, method: 'post' });
export const verifyTax = (id) => callApi({ url: `/teachers/${id}/verify/tax-information`, method: 'post' });
export const rejectBankAccount = (id) => callApi({ url: `/teachers/${id}/reject/bank-account`, method: 'post' });
export const rejectTax = (id) => callApi({ url: `/teachers/${id}/reject/tax-information`, method: 'post' });

export const editTeacher = (id, data) => callApi({ url: `/teachers/${id}`, body: data, method: 'put' });
export const updateDiscount = (id, data) => callApi({ url: `/teachers/${id}/discount`, body: data, method: 'put' });

export const getAutocompleteTeachers = (params) => callApi({ url: '/teachers/autocomplete', query: params });
